import { FC } from 'react';
import NavCommon from '../NavCommon';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

interface IProps {
    type?: string;
}

const Banner: FC<IProps> = ({}) => {
    const { locale } = getLocal();
    const { t } = useLang('membersday.teaser.Nav');
    const defaultList: any[] = [
        {
            title: t('title1'),
            href: 'teaser-CelebratingUs',
        },
        {
            title: t('title2'),
            href: 'teaser-JoinUs',
        },
        {
            title: t('title3'),
            href: 'teaser-ReferralNext',
        },
        {
            title: t('title4'),
            href: 'teaser-EcoBenefits',
        },
        {
            title: t('title5'),
            href: 'teaser-ActivityPreview',
        },
    ];
    const jpList = [
        {
            title: t('title1'),
            href: 'teaser-CelebratingUs',
        },
        {
            title: t('title2'),
            href: 'teaser-JoinUs',
        },
        {
            title: t('title4'),
            href: 'teaser-EcoBenefits',
        },
        {
            title: t('title5'),
            href: 'teaser-ActivityPreview',
        },
        {
            title: t('title3'),
            href: 'teaser-ReferralNext',
        },
    ];
    const list = locale === 'jp' ? jpList : defaultList;

    return (
        <>
            <NavCommon list={list} />
        </>
    );
};

export default Banner;
